import React from 'react';
import logo from './assets/logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Work in Progress
        </p>
      </header>
    </div>
  );
}

export default App;
